import { OfferSelectionPopup } from './offerSelection.popup.tsx';

export const offerSelectionPopup = new OfferSelectionPopup();
